import {Component, HostListener, OnInit} from '@angular/core'
import {SharedApiService} from '../../../shared/services/api.service'
import {NgbModal} from '@ng-bootstrap/ng-bootstrap'
import {QuestionModalComponent} from './components/question-modal/question-modal.component'
import {NavigationEnd, Router} from '@angular/router'
import {filter} from 'rxjs/operators'
import {AuthService} from '../../../shared/services/auth.service'
import {RegistrationToast} from '../../../shared/models/registrationToast.model'
import {User} from '../../../shared/models/user.model'
import {Store} from '@ngrx/store'
import {AuthenticationState} from '../../../shared/store/auth/auth.model'
import {EnvService} from '../../../shared/services/env.service'
import {slugify} from '../../../shared/util/slugify'

@Component(
    {
        selector: `app-footer`,
        templateUrl: `./footer.component.html`,
        styleUrls: [
            `./footer.component.scss`,
        ],
    },
)
export class FooterComponent implements OnInit {
    @HostListener(
        `window:scroll`,
        [
            `$event`,
        ],
    )
    onWindowScroll() {
        if (window.scrollY >= 640) {
            this.scrolled = true;
        }
    }

    public organisations = [];
    private isPartnerPage: boolean = false;
    public scrolled: boolean = false;
    public showCookieBar: boolean = true;
    public showToast: boolean = true;
    public user?: User;
    public currentYear: number;

    constructor(
        public apiService: SharedApiService,
        public authService: AuthService,
        public store: Store<{ auth: AuthenticationState }>,
        public envService: EnvService,
        private modalService: NgbModal,
        private router: Router,
    ) {
        if (localStorage.getItem(`cookiesConsent`)) {
            this.showCookieBar = false;
        }

        if (localStorage.getItem(`registrationToast`)) {
            let registrationToast = JSON.parse(localStorage.getItem(`registrationToast`));

            if (registrationToast.expiry > (new Date()).getTime()) {
                this.showToast = false;
            }
        }

        this.store.select(`auth`).subscribe((state: AuthenticationState) => {
            this.user = state.user;
        });

        this.currentYear = new Date().getFullYear();
    }

    public ngOnInit() {
        this.router.events.pipe(filter(navigationEnd => navigationEnd instanceof NavigationEnd)).subscribe((navigationEnd: any) => {
            this.isPartnerPage = navigationEnd.url.startsWith(`/content/partner/`);
        });
    }

    public openQuestionModal() {
        const modalRef = this.modalService.open(QuestionModalComponent, {size: `lg`, backdrop: `static`});
        modalRef.componentInstance.isPartnerPage = this.isPartnerPage;
    }

    public closeToast() {
        let registrationToast: RegistrationToast = {
            expiry: (new Date()).getTime() + (30 * 86400000), // 30 days * 86400000 milliseconds per day
        };

        localStorage.setItem(`registrationToast`, JSON.stringify(registrationToast));

        this.showToast = false;
    }

    public acceptCookies(cookies: string): void {
        localStorage.setItem(`cookiesConsent`, cookies);

        this.showCookieBar = false;
    }

    public slug(name: string) {
        return slugify(name);
    }
}
